import { render, staticRenderFns } from "./Damage.vue?vue&type=template&id=671213b2&scoped=true&"
import script from "./Damage.vue?vue&type=script&lang=js&"
export * from "./Damage.vue?vue&type=script&lang=js&"
import style0 from "./Damage.vue?vue&type=style&index=0&id=671213b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671213b2",
  null
  
)

export default component.exports